import { CommonModule } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-form-section-header',
  styleUrls: ['form-sectionHeader.component.scss'],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section col-12"
        tabindex="0"
        [innerHTML]="props.label"
        [ngClass]="{ border: to.labelBorder }"
      ></label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }
  `,
  imports: [CommonModule],
})
export class FormlySectionHeaderComponent extends FieldType {
  @HostBinding('class') classes = 'header-section';

  constructor() {
    super();
  }
}
